import{useState as r,useEffect as o}from"react";import s from"../assets/images/imgFallback.png.js";const t=(t,e=s)=>{const[m,a]=r(!1),[c,n]=r(t||"");return o((()=>{t&&(a(!1),n(t))}),[t]),{src:c,onError:()=>{n(e),a(!0)},error:m}};export{t as useFallbackImg};
//# sourceMappingURL=useFallbackImg.js.map
